import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nft-details-1.png'
import _imports_1 from '@/assets/images/nft-details-2.png'
import _imports_2 from '@/assets/images/nft-details-3.png'
import _imports_3 from '@/assets/images/nft-details-4.png'
import _imports_4 from '@/assets/images/user-76.gif'
import _imports_5 from '@/assets/images/verify.svg'
import _imports_6 from '@/assets/images/schedule2.png'
import _imports_7 from '@/assets/images/nft-17.png'
import _imports_8 from '@/assets/images/nft-18.png'
import _imports_9 from '@/assets/images/nft-19.png'
import _imports_10 from '@/assets/images/nft-20.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-8" }
const _hoisted_3 = { class: "card border-0 rounded-2 p-4 bg-white mb-4" }
const _hoisted_4 = { class: "d-flex flex-wrap justify-content-between gap-3 rounded-3 bg-body-bg p-3 mb-5" }
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountdownTimer = _resolveComponent("CountdownTimer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-4" }, [
      _createElementVNode("div", { class: "mb-4" }, [
        _createElementVNode("div", {
          class: "tab-content mb-3 card border-0 bg-white p-3 rounded-2",
          id: "myTabContent"
        }, [
          _createElementVNode("div", {
            class: "tab-pane fade show active",
            id: "nft-details1-tab-pane",
            role: "tabpanel",
            "aria-labelledby": "nft-details1-tab",
            tabindex: "0"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "rounded-2",
              alt: "nft-details"
            })
          ]),
          _createElementVNode("div", {
            class: "tab-pane fade",
            id: "nft-details2-tab-pane",
            role: "tabpanel",
            "aria-labelledby": "nft-details2-tab",
            tabindex: "0"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "rounded-2",
              alt: "nft-details"
            })
          ]),
          _createElementVNode("div", {
            class: "tab-pane fade",
            id: "nft-details3-tab-pane",
            role: "tabpanel",
            "aria-labelledby": "nft-details3-tab",
            tabindex: "0"
          }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "rounded-2",
              alt: "nft-details"
            })
          ]),
          _createElementVNode("div", {
            class: "tab-pane fade",
            id: "nft-details4-tab-pane",
            role: "tabpanel",
            "aria-labelledby": "nft-details4-tab",
            tabindex: "0"
          }, [
            _createElementVNode("img", {
              src: _imports_3,
              class: "rounded-2",
              alt: "nft-details"
            })
          ])
        ]),
        _createElementVNode("ul", {
          class: "nav nav-tabs gap-3 nft-detail-tabs border-0 justify-content-center",
          id: "myTab",
          role: "tablist"
        }, [
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link p-0 border-0 active",
              id: "nft-details1-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nft-details1-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "nft-details1-tab-pane",
              "aria-selected": "true"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "rounded-2",
                style: {"width":"110px"},
                alt: "nft-details"
              })
            ])
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link p-0 border-0",
              id: "nft-details2-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nft-details2-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "nft-details2-tab-pane",
              "aria-selected": "false"
            }, [
              _createElementVNode("img", {
                src: _imports_1,
                class: "rounded-2",
                style: {"width":"110px"},
                alt: "nft-details"
              })
            ])
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link p-0 border-0",
              id: "nft-details3-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nft-details3-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "nft-details3-tab-pane",
              "aria-selected": "false"
            }, [
              _createElementVNode("img", {
                src: _imports_2,
                class: "rounded-2",
                style: {"width":"110px"},
                alt: "nft-details"
              })
            ])
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link p-0 border-0",
              id: "nft-details4-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nft-details4-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "nft-details4-tab-pane",
              "aria-selected": "false"
            }, [
              _createElementVNode("img", {
                src: _imports_3,
                class: "rounded-2",
                style: {"width":"110px"},
                alt: "nft-details"
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("button", { class: "btn btn-primary py-2 px-4 w-100 mb-4" }, "Place Bid")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"border-bottom mb-3 pb-3\"><span class=\"fs-12 d-block mb-1\">NFT ID: 35246</span><h3 class=\"fs-24 mb-0\">Christmas Eve</h3></div><div class=\"d-flex flex-wrap gap-2 gap-sm-5 mb-4\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0 position-relative\"><img src=\"" + _imports_4 + "\" class=\"rounded-circle\" style=\"width:30px;height:30px;\" alt=\"user\"><img src=\"" + _imports_5 + "\" class=\"position-absolute top-100 start-100 translate-middle\" style=\"width:18px;height:18px;\" alt=\"verify\"></div><div class=\"flex-grow-1 ms-3\"><span class=\"fs-12\">Creator</span><h4 class=\"fs-14 fw-semibold\">Anan Loren</h4></div></div><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0 position-relative\"><img src=\"" + _imports_6 + "\" style=\"width:30px;height:30px;\" alt=\"schedule2\"></div><div class=\"flex-grow-1 ms-3\"><span class=\"fs-12\">Published</span><h4 class=\"fs-14 fw-semibold\">23 June 2024</h4></div></div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"text-center\"><span class=\"fs-12 d-block mb-1 text-body\">Price:</span><h3 class=\"mb-0 fw-semibold fs-14\">5.50 ETH</h3></div><div class=\"text-center\"><span class=\"fs-12 d-block mb-1 text-body\">Highest Bid:</span><h3 class=\"mb-0 fw-semibold fs-14\">4.95 ETH</h3></div><div class=\"text-center\"><span class=\"fs-12 d-block mb-1 text-body\">Stock:</span><h3 class=\"mb-0 fw-semibold fs-14\">130/450</h3></div><div class=\"text-center\"><span class=\"fs-12 d-block mb-1 text-body\">Price:</span><h3 class=\"mb-0 fw-semibold fs-14\">5.50 ETH</h3></div>", 4)),
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fs-12 d-block mb-1 text-body" }, "Auction End In:", -1)),
            _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "fs-18 mb-3" }, "Description", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-5" }, " This NFT captures the essence of boundless potential, symbolized by a surreal landscape where the sky meets the earth in a dazzling fusion of colors. The intricate design features flowing lines that blend together, representing the limitless paths we can take in life. ", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card bg-white border-0 rounded-3" }, [
          _createElementVNode("div", { class: "card-body p-0" }, [
            _createElementVNode("h3", { class: "mb-4" }, "Product Description"),
            _createElementVNode("ul", {
              class: "nav nav-tabs bg-transparent border-bottom gap-3 gap-sm-5 pb-4 live-auction",
              id: "myTab",
              role: "tablist"
            }, [
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body active",
                  id: "place-bids-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#place-bids-tab-pane",
                  type: "button",
                  role: "tab",
                  "aria-controls": "place-bids-tab-pane",
                  "aria-selected": "true"
                }, " PLACE BIDS ")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body",
                  id: "additional-information-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#additional-information-tab-pane",
                  type: "button",
                  role: "tab",
                  "aria-controls": "additional-information-tab-pane",
                  "aria-selected": "false"
                }, " ADDITIONAL INFORMATION ")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body",
                  id: "details-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#details-tab-pane",
                  type: "button",
                  role: "tab",
                  "aria-controls": "details-tab-pane",
                  "aria-selected": "false"
                }, " DETAILS ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-content",
              id: "myTabContent"
            }, [
              _createElementVNode("div", {
                class: "tab-pane fade show active",
                id: "place-bids-tab-pane",
                role: "tabpanel",
                "aria-labelledby": "place-bids-tab",
                tabindex: "0"
              }, [
                _createElementVNode("div", { class: "default-table-area style-two campaigns-table only-for-responsive-table" }, [
                  _createElementVNode("div", { class: "table-responsive" }, [
                    _createElementVNode("table", { class: "table align-middle border-0 w-100" }, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_7,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Christmas Eve "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.00 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 30 mins ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_8,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Rotating Flower "),
                                _createElementVNode("span", { class: "fs-12" }, "by WalterW.")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "9.25 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "6.10 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "1 hr ago")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_9,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Windows Art "),
                                _createElementVNode("span", { class: "fs-12" }, "by Christino")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "17.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 1.30 hr ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_10,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Awesome Bird "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "12.12 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 35 mins ago ")
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-pane fade",
                id: "additional-information-tab-pane",
                role: "tabpanel",
                "aria-labelledby": "additional-information-tab",
                tabindex: "0"
              }, [
                _createElementVNode("div", { class: "default-table-area style-two campaigns-table only-for-responsive-table" }, [
                  _createElementVNode("div", { class: "table-responsive" }, [
                    _createElementVNode("table", { class: "table align-middle border-0 w-100" }, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_9,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Windows Art "),
                                _createElementVNode("span", { class: "fs-12" }, "by Christino")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "17.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 1.30 hr ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_10,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Awesome Bird "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "12.12 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 35 mins ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_7,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Christmas Eve "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.00 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 30 mins ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_8,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Rotating Flower "),
                                _createElementVNode("span", { class: "fs-12" }, "by WalterW.")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "9.25 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "6.10 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "1 hr ago")
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-pane fade",
                id: "details-tab-pane",
                role: "tabpanel",
                "aria-labelledby": "details-tab",
                tabindex: "0"
              }, [
                _createElementVNode("div", { class: "default-table-area style-two campaigns-table only-for-responsive-table" }, [
                  _createElementVNode("div", { class: "table-responsive" }, [
                    _createElementVNode("table", { class: "table align-middle border-0 w-100" }, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_7,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Christmas Eve "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.00 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 30 mins ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_8,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Rotating Flower "),
                                _createElementVNode("span", { class: "fs-12" }, "by WalterW.")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "9.25 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "6.10 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "1 hr ago")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_9,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Windows Art "),
                                _createElementVNode("span", { class: "fs-12" }, "by Christino")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "17.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "11.75 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 1.30 hr ago ")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "d-flex align-items-center" }, [
                              _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("img", {
                                  src: _imports_10,
                                  class: "rounded-3",
                                  style: {"width":"50px","height":"50px"},
                                  alt: "nft"
                                })
                              ]),
                              _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                                _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, " Awesome Bird "),
                                _createElementVNode("span", { class: "fs-12" }, "by John Lira")
                              ])
                            ])
                          ]),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "12.12 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, "10.24 ETH"),
                          _createElementVNode("td", { class: "fs-12 fw-semibold text-body" }, " 35 mins ago ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], -1))
      ])
    ])
  ]))
}